const cards = [
  {
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20cinematic%20visual%20representing%20action%20movies%20with%20abstract%20dynamic%20shapes%20in%20coral%20and%20amber%20tones%2C%20modern%20minimalist%20design%2C%20soft%20dramatic%20lighting%2C%20clean%20composition&width=800&height=500&seq=card-01&orientation=landscape',
    alt: '动作电影精选',
    tag: '豆瓣8.5+',
    title: '2025年度动作电影精选',
    desc: '集结全年最受好评的动作大片，拳拳到肉的打斗场面与震撼视觉特效，每部都是不容错过的精品。',
    meta: '已收录 186 部',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=An%20elegant%20romantic%20cinematic%20visual%20with%20soft%20warm%20coral%20and%20gold%20abstract%20shapes%2C%20gentle%20atmosphere%2C%20modern%20minimalist%20design%2C%20emotional%20warmth&width=800&height=500&seq=card-02&orientation=landscape',
    alt: '爱情剧集推荐',
    tag: '热门精选',
    title: '这个夏天最甜的十部言情剧',
    desc: '从校园到都市，从古装到现代，精心挑选十部高甜高颜值的言情剧集，陪你度过美好时光。',
    meta: '持续更新中',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20comedic%20entertainment%20visual%20with%20warm%20playful%20abstract%20shapes%20in%20soft%20coral%20and%20amber%2C%20light%20atmosphere%2C%20modern%20clean%20design%2C%20fun%20energy&width=800&height=500&seq=card-03&orientation=landscape',
    alt: '喜剧电影合集',
    tag: '笑到肚子疼',
    title: '国产喜剧电影大合集',
    desc: '开心麻花、徐峥、黄渤等喜剧大咖经典作品全收录，高清画质一网打尽，随时打开笑一笑。',
    meta: '已收录 230 部',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20suspenseful%20visual%20with%20warm%20dark%20amber%20and%20coral%20abstract%20geometric%20shapes%2C%20dramatic%20atmosphere%2C%20modern%20minimalist%20design%2C%20intriguing%20depth&width=800&height=500&seq=card-04&orientation=landscape',
    alt: '悬疑推理剧',
    tag: '烧脑必看',
    title: '细思极恐的悬疑推理剧单',
    desc: '精选国内外高能悬疑推理剧集，反转再反转的剧情让你停不下来，每一部都值得二刷。',
    meta: '已收录 142 部',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20futuristic%20sci-fi%20visual%20with%20warm%20coral%20and%20amber%20abstract%20geometric%20shapes%2C%20modern%20minimalist%20design%2C%20clean%20technology%20aesthetic%2C%20soft%20glowing%20elements&width=800&height=500&seq=card-05&orientation=landscape',
    alt: '科幻电影大全',
    tag: '视觉盛宴',
    title: '一生必看的科幻电影大全',
    desc: '从《星际穿越》到《流浪地球》，从《黑客帝国》到《阿凡达》，科幻迷的终极片单。',
    meta: '已收录 168 部',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20nostalgic%20classical%20Chinese%20style%20visual%20with%20soft%20coral%20and%20amber%20abstract%20shapes%2C%20elegant%20traditional%20motif%2C%20modern%20minimalist%20design%2C%20cultural%20depth&width=800&height=500&seq=card-06&orientation=landscape',
    alt: '古装剧推荐',
    tag: '国风美学',
    title: '近五年最佳古装剧推荐',
    desc: '服化道精良、剧情扎实的古装剧精选，每一帧都是壁纸，每一集都值得细细品味。',
    meta: '已收录 95 部',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20global%20international%20entertainment%20visual%20with%20warm%20coral%20and%20amber%20abstract%20shapes%2C%20world%20map%20motif%2C%20modern%20minimalist%20design%2C%20open%20atmosphere&width=800&height=500&seq=card-07&orientation=landscape',
    alt: '海外热门剧',
    tag: '全球热播',
    title: '海外热门剧集一网打尽',
    desc: '美剧、韩剧、日剧、泰剧等海外优质内容全收录，中文字幕同步更新，追剧无忧。',
    meta: '持续更新中',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            编辑团队为你精心挑选的优质影视内容
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.slice(0, 6).map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-white border border-background-200/70 hover:border-primary-200 transition-all duration-300 flex flex-col"
            >
              <div className="relative overflow-hidden h-48">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500/90 text-white text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-base font-semibold text-foreground-950 mb-2 font-serif">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed flex-1">
                  {item.desc}
                </p>
                <div className="mt-3 pt-3 border-t border-background-200 flex items-center justify-between">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-film-line"></i>
                    {item.meta}
                  </span>
                  <span className="text-xs text-primary-500 font-medium flex items-center gap-1 cursor-pointer hover:text-primary-600 transition-colors">
                    立即观看
                    <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
        {cards.length > 6 && (
          <div className="mt-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {cards.slice(6).map((item, idx) => (
                <div
                  key={idx + 6}
                  className="group rounded-xl overflow-hidden bg-white border border-background-200/70 hover:border-primary-200 transition-all duration-300 flex flex-col"
                >
                  <div className="relative overflow-hidden h-48">
                    <img
                      src={item.img}
                      alt={item.alt}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-2.5 py-1 rounded-full bg-accent-500/90 text-white text-xs font-medium">
                        {item.tag}
                      </span>
                    </div>
                  </div>
                  <div className="p-5 flex flex-col flex-1">
                    <h3 className="text-base font-semibold text-foreground-950 mb-2 font-serif">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed flex-1">
                      {item.desc}
                    </p>
                    <div className="mt-3 pt-3 border-t border-background-200 flex items-center justify-between">
                      <span className="text-xs text-foreground-400 flex items-center gap-1">
                        <i className="ri-film-line"></i>
                        {item.meta}
                      </span>
                      <span className="text-xs text-primary-500 font-medium flex items-center gap-1 cursor-pointer hover:text-primary-600 transition-colors">
                        立即观看
                        <i className="ri-arrow-right-s-line"></i>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}